import { Path, Location, To } from "react-router-dom";

export function mergeSearch(path: Path, location: Location) {
  const result = [
    path.search.split("?").join(""),
    location.search
      .split("?")
      .join("")
      .split("&")
      .filter(
        (param) => !param.startsWith("reffer") && !param.startsWith("?reffer")
      )
      .join("&"),
  ]
    .filter((queryParams) => !!queryParams)
    .join("&");

  return result;
}

export function mergeLocation(
  to: To,
  path: Path,
  location: Location,
  search: string
) {
  if (typeof to === "string") {
    return {
      ...location,
      ...path,
      search: `?${search}`,
    };
  } else {
    return { ...location, ...to };
  }
}
